export default {"src":"/_next/static/image/public/images/ic_aster_secure_white_vertical_menu.e275171a3031d181eccda9981c49d680.svg","height":20,"width":20};